module.exports = __webpack_public_path__ + "img/2.10b51698.jpg";